/**
 * ⟦C62 · lot arbre · A-179⟧ **L'Arbre se dévoile marche par marche** : quels nœuds d'une branche s'écrivent à l'écran.
 *
 * Matt, 21/10/2026 : à 100 abonnés, 2 points à dépenser et 42 nœuds d'un coup. Avec `meta.arbre_progressif`, une
 * branche ne montre que ce que le joueur a pris (rangé en une ligne chacun) et ce qu'il peut prendre ensuite,
 * c'est-à-dire les nœuds dont TOUS les prérequis sont pris : un nœud par branche au départ, le suivant au moment
 * où le sien est pris. Un nœud à porte d'abonnés (le guide MeTube, le producteur) se montre dès que son prérequis
 * est pris, grisé avec sa porte écrite : c'est une promesse, et une promesse se voit ⟦A-43⟧.
 *
 * Sans le réglage (`progressif` à `false`, l'état neutre ⟦A-10⟧), tout ce qui n'est pas pris s'écrit, comme avant.
 *
 * Pur : aucun DOM, aucun store. Il ne décide rien du jeu (un prix, un prérequis, un effet) : il choisit ce qui
 * s'affiche. Le moteur reste seul juge de l'achat (`refusAchat`).
 */

/** Ce que cette règle lit d'un nœud : son identifiant, son palier, ses prérequis. */
export interface NoeudDeBranche {
  id: string;
  tier: number;
  prerequis?: readonly string[];
}

export interface BrancheAffichee<T> {
  /** Les nœuds pris, dans l'ordre des paliers : une ligne chacun. */
  acquis: T[];
  /** Les nœuds à prendre qui s'écrivent : une carte chacun. */
  suivants: T[];
}

export function affichageDeLaBranche<T extends NoeudDeBranche>(
  noeuds: readonly T[],
  possedes: readonly string[],
  progressif: boolean,
): BrancheAffichee<T> {
  const pris = new Set(possedes);
  const parPalier = [...noeuds].sort((a, b) => a.tier - b.tier);
  const acquis = parPalier.filter((n) => pris.has(n.id));
  const suivants = parPalier.filter(
    (n) => !pris.has(n.id) && (!progressif || (n.prerequis ?? []).every((p) => pris.has(p))),
  );
  return { acquis, suivants };
}
